module.exports = __webpack_public_path__ + "img/teams-head-right-arrow.7561ef3c.svg";